// src/reducers/usersReducer.js

export const ACTIONS = {
    FETCH_INIT: "FETCH_INIT",
    FETCH_SUCCESS: "FETCH_SUCCESS",
    FETCH_FAILURE: "FETCH_FAILURE",
    SET_ORDER: "SET_ORDER",
    SET_ORDER_BY: "SET_ORDER_BY",
    SET_PAGE: "SET_PAGE",
    SET_ROWS_PER_PAGE: "SET_ROWS_PER_PAGE",
  };
  
  export const initialState = {
    users: [],
    loading: false,
    error: null,
    order: "asc",
    orderBy: "name",
    page: 0,
    rowsPerPage: 25,
    totalUsers: 0,
  };
  
  export function usersReducer(state, action) {
    switch (action.type) {
      case ACTIONS.FETCH_INIT:
        return { ...state, loading: true, error: null };
      case ACTIONS.FETCH_SUCCESS:
        return { ...state, loading: false, users: action.payload.users, totalUsers: action.payload.total };
      case ACTIONS.FETCH_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case ACTIONS.SET_ORDER:
        return { ...state, order: action.payload };
      case ACTIONS.SET_ORDER_BY:
        return { ...state, orderBy: action.payload };
      case ACTIONS.SET_PAGE:
        return { ...state, page: action.payload };
      case ACTIONS.SET_ROWS_PER_PAGE:
        return { ...state, rowsPerPage: action.payload, page: 0 };
      default:
        return state;
    }
  }  